/* TARZ — Predictive / live search dropdown */
(function () {
  const DEBOUNCE_MS = 280;
  const MIN_CHARS = 2;

  const MOCK = {
    products: [
      { title: 'Sage Leaf Printed Lawn', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC00960.jpg?v=1776710785', vendor: 'TARZ', price: 'Rs.4,999' },
      { title: 'Embroidered Kimono Co-ord Set', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC01023.jpg?v=1776710128', vendor: 'TARZ', price: 'Rs.5,400' },
      { title: 'Navy Blue Printed Lawn Suit', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC00812.jpg?v=1776710552', vendor: 'TARZ', price: 'Rs.5,400' },
      { title: 'Printed Sleepwear Set', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC00926.jpg?v=1776723279', vendor: 'TARZ', price: 'Rs.4,999' }
    ],
    collections: [
      { title: 'Summer Collection', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC00997.jpg?v=1776710240' },
      { title: 'Sleepwear', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC00926.jpg?v=1776723279' },
      { title: 'Festive Collection', url: '#', image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/QAP02582.jpg?v=1764890196' }
    ],
    queries: [
      { text: 'summer lawn 3 piece', url: '#' },
      { text: 'sleepwear co-ord set', url: '#' },
      { text: 'festive embroidered suit', url: '#' },
      { text: 'new arrivals lawn', url: '#' }
    ]
  };

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(price) {
    if (price == null || price === '') return '';
    if (typeof price === 'string') return price;
    return 'Rs.' + (Number(price) / 100).toLocaleString('en-PK');
  }

  function productImage(p) {
    return p.image || p.featured_image?.url || p.featured_image || '';
  }

  function buildSuggestUrl(q, scope) {
    const types =
      scope === 'product' ? 'product' :
      scope === 'collection' ? 'collection' :
      'product,collection,query';
    const params = new URLSearchParams({
      q,
      'resources[type]': types,
      'resources[limit]': '10',
      'resources[options][unavailable_products]': 'hide'
    });
    return `/search/suggest.json?${params}`;
  }

  function filterMock(q, scope) {
    const term = q.toLowerCase();
    const match = (s) => String(s || '').toLowerCase().includes(term);
    let products = MOCK.products.filter(p => match(p.title) || match(p.vendor));
    let collections = MOCK.collections.filter(c => match(c.title));
    let queries = MOCK.queries.filter(x => match(x.text));
    if (!products.length && !collections.length && !queries.length) {
      products = MOCK.products;
      collections = MOCK.collections;
      queries = MOCK.queries;
    }
    if (scope === 'product') return { products, collections: [], queries: [] };
    if (scope === 'collection') return { products: [], collections, queries: [] };
    return { products, collections, queries };
  }

  function extractBrands(products) {
    const seen = new Set();
    const brands = [];
    products.forEach(p => {
      const name = (p.vendor || '').trim();
      if (!name || seen.has(name.toLowerCase())) return;
      seen.add(name.toLowerCase());
      brands.push({ name, url: `/collections/vendors?q=${encodeURIComponent(name)}`, image: productImage(p) });
    });
    return brands.slice(0, 6);
  }

  function renderSection(title, inner) {
    if (!inner) return '';
    return `<section class="predictive-section"><h3 class="predictive-section-title">${escapeHtml(title)}</h3>${inner}</section>`;
  }

  function renderBrands(brands) {
    if (!brands.length) return '';
    const items = brands.map(b => `
      <a href="${escapeHtml(b.url)}" class="predictive-brand-item">
        <span class="predictive-brand-logo">${b.image ? `<img src="${escapeHtml(b.image)}" alt="" width="56" height="56" loading="lazy">` : `<span class="predictive-brand-placeholder">${escapeHtml(b.name.charAt(0))}</span>`}</span>
        <span class="predictive-brand-name">${escapeHtml(b.name)}</span>
      </a>`).join('');
    return renderSection('Brands', `<div class="predictive-brands-row">${items}</div>`);
  }

  function renderProducts(products) {
    if (!products.length) return '';
    const items = products.map(p => `
      <a href="${escapeHtml(p.url)}" class="predictive-product-item">
        <span class="predictive-product-img">${productImage(p) ? `<img src="${escapeHtml(productImage(p))}" alt="" width="100" height="100" loading="lazy">` : ''}</span>
        <span class="predictive-product-title">${escapeHtml(p.title)}</span>
        ${p.vendor ? `<span class="predictive-product-vendor">${escapeHtml(p.vendor)}</span>` : ''}
      </a>`).join('');
    return renderSection('Products', `<div class="predictive-products-row">${items}</div>`);
  }

  function renderCategories(queries, collections) {
    const items = [];
    queries.forEach(q => {
      const text = q.text || q.styled_text || '';
      const url = q.url || '#';
      items.push(`<a href="${escapeHtml(url)}" class="predictive-category-item">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
        <span>${escapeHtml(text)}</span>
      </a>`);
    });
    collections.forEach(c => {
      items.push(`<a href="${escapeHtml(c.url)}" class="predictive-category-item">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
        <span>${escapeHtml(c.title)}</span>
      </a>`);
    });
    if (!items.length) return '';
    return renderSection('Categories', `<div class="predictive-categories-list">${items.join('')}</div>`);
  }

  function renderResults(data, q) {
    const products = data.products || [];
    const collections = data.collections || [];
    const queries = data.queries || [];
    const brands = extractBrands(products);

    if (!products.length && !collections.length && !queries.length && !brands.length) {
      return `<div class="predictive-empty">No results for &ldquo;${escapeHtml(q)}&rdquo;</div>`;
    }

    return [
      renderBrands(brands),
      renderProducts(products.slice(0, 8)),
      renderCategories(queries.slice(0, 6), collections.slice(0, 4))
    ].filter(Boolean).join('');
  }

  async function fetchSuggestions(q, scope, useMock) {
    if (useMock) {
      await new Promise(r => setTimeout(r, 120));
      return filterMock(q, scope);
    }
    const res = await fetch(buildSuggestUrl(q, scope));
    if (!res.ok) throw new Error('suggest failed');
    const json = await res.json();
    const r = json.resources?.results || json.resources || {};
    return {
      products: r.products || [],
      collections: r.collections || [],
      queries: r.queries || []
    };
  }

  function init(root) {
    const form = root.querySelector('.predictive-search-form');
    const input = root.querySelector('[data-predictive-input]');
    const clearBtn = root.querySelector('[data-search-clear]');
    const dropdown = root.querySelector('[data-predictive-dropdown]');
    const resultsEl = root.querySelector('[data-predictive-results]');
    const loadingEl = root.querySelector('[data-predictive-loading]');
    const scopeWrap = root.querySelector('[data-search-scope]');
    const scopeBtn = root.querySelector('[data-scope-btn]');
    const scopeMenu = root.querySelector('[data-scope-menu]');
    const scopeLabel = root.querySelector('[data-scope-label]');
    const typeField = root.querySelector('[data-search-type-field]');

    if (!form || !input || !dropdown || !resultsEl) return;

    let scope = 'all';
    let timer = null;
    let abort = null;
    const useMock = root.dataset.mock === 'true';

    function setOpen(open) {
      dropdown.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-open', open);
    }

    function updateClear() {
      const has = input.value.trim().length > 0;
      clearBtn.hidden = !has;
    }

    function closeScopeMenu() {
      if (!scopeMenu) return;
      scopeMenu.hidden = true;
      scopeBtn?.setAttribute('aria-expanded', 'false');
    }

    scopeBtn?.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const open = scopeMenu.hidden;
      scopeMenu.hidden = !open;
      scopeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    scopeMenu?.querySelectorAll('[role="option"]').forEach(opt => {
      opt.addEventListener('click', () => {
        scope = opt.dataset.scope || 'all';
        scopeLabel.textContent = opt.textContent.trim();
        scopeMenu.querySelectorAll('[role="option"]').forEach(o => o.setAttribute('aria-selected', o === opt ? 'true' : 'false'));
        if (typeField) typeField.value = scope === 'collection' ? 'collection' : 'product';
        closeScopeMenu();
        if (input.value.trim().length >= MIN_CHARS) runSearch(input.value.trim());
      });
    });

    clearBtn?.addEventListener('click', () => {
      input.value = '';
      updateClear();
      resultsEl.innerHTML = '';
      setOpen(false);
      input.focus();
    });

    async function runSearch(q) {
      if (abort) abort.abort();
      abort = new AbortController();
      loadingEl.hidden = false;
      setOpen(true);
      try {
        const data = await fetchSuggestions(q, scope, useMock);
        if (abort.signal.aborted) return;
        resultsEl.innerHTML = renderResults(data, q);
      } catch {
        if (!useMock) {
          try {
            const data = await fetchSuggestions(q, scope, true);
            resultsEl.innerHTML = renderResults(data, q);
          } catch {
            resultsEl.innerHTML = '<div class="predictive-empty">Could not load suggestions.</div>';
          }
        } else {
          resultsEl.innerHTML = '<div class="predictive-empty">Could not load suggestions.</div>';
        }
      } finally {
        loadingEl.hidden = true;
      }
    }

    input.addEventListener('input', () => {
      updateClear();
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN_CHARS) {
        resultsEl.innerHTML = '';
        setOpen(false);
        return;
      }
      timer = setTimeout(() => runSearch(q), DEBOUNCE_MS);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= MIN_CHARS) setOpen(true);
    });

    form.addEventListener('submit', e => {
      if (input.value.trim().length < MIN_CHARS) {
        e.preventDefault();
      }
    });

    document.addEventListener('click', e => {
      if (!root.contains(e.target)) {
        setOpen(false);
        closeScopeMenu();
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        setOpen(false);
        closeScopeMenu();
      }
    });

    updateClear();
    const initial = input.value.trim();
    if (initial.length >= MIN_CHARS) runSearch(initial);
  }

  function boot() {
    document.querySelectorAll('[data-predictive-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
